import DetailsLayout from './DetailsLayout';
import FormLayout from './FormLayout';
import FormPageLayout from './FormPageLayout';
import renderFormSection from './renderFormSection';
import StaticFormLayout from './StaticFormLayout';

export {
  DetailsLayout,
  FormLayout,
  FormPageLayout,
  renderFormSection,
  StaticFormLayout,
};



// WEBPACK FOOTER //
// ./src/modules/common/layouts/index.js